import { Box, Button, ButtonGroup, Container, Grid, Typography } from "@mui/material"
import { GlobalLoaderContext } from "components/GlobalLoadingProvider"
import { allRoutes } from "generated/routes"
import { DashboardCard } from "pages/vehicleregistry/pages/dashboard/DashboardCard/DashboardCard"
import React, { useContext, useEffect } from "react"
import LastUpdatedDate from "../LastUpdatedDate/LastUpdatedDate"
import { useTranslation } from "react-i18next"
import { faFileImport } from "@fortawesome/pro-solid-svg-icons"

const Header = (props) => {
  const { openAdd, dashboardResult, lastUpdatedDate } = props
  const { t } = useTranslation()

  // loading while waiting
  const loadingContext = useContext(GlobalLoaderContext)
  useEffect(() => {
    loadingContext.setLoading(() => dashboardResult.status === 1)
  })

  return (
    <Container>
      <Box>
        <Grid container direction="row" justifyContent="space-between" alignItems="center">
          <Typography mb={{ xs: 2, lg: 0 }} variant="h1">
            {t("global.import_from_the_transport_agency", "Import from the Transport Agency")}
          </Typography>
          <Button
            color="primary"
            onClick={() => {
              openAdd()
            }}
            variant="contained">
            {t("global.import_from_the_transport_agency", "Import from the Transport Agency")}
          </Button>
        </Grid>
      </Box>

      <LastUpdatedDate date={lastUpdatedDate} />

      {dashboardResult && (
        <Grid spacing={2} container direction="row">
          <Grid item md={4} lg={3} direction="column">
            <DashboardCard
              icon={faFileImport}
              route={allRoutes.VehicleregistryVehiclesImportvtr()}
              itemLength={dashboardResult.length}
              title={t("global.import_from_the_transport_agency", "Import from the Transport Agency")}
              quantityType={t("global.pc", "pcs")}
            />
          </Grid>
        </Grid>
      )}
    </Container>
  )
}

export default Header
